export const WARRANTY_IN = 1;
export const WARRANTY_OUT = 2;

export const toDateOrNull = (value) => {
    if (!value) return null;
    if (value instanceof Date && !Number.isNaN(value.getTime())) return value;

    if (typeof value === 'string' && /^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
        const [day, month, year] = value.split('.');
        const parsed = new Date(Number(year), Number(month) - 1, Number(day));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const isDateInRange = (targetDate, startDate, endDate) => {
    if (!targetDate || !startDate || !endDate) return false;

    const target = new Date(targetDate);
    const start = new Date(startDate);
    const end = new Date(endDate);
    target.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    return target.getTime() >= start.getTime() && target.getTime() <= end.getTime();
};

export const getWarrantyRecords = (records, chassisNo, zNumber) => {
    const normalizedChassisNo = String(chassisNo || '').trim().toUpperCase();
    if (!normalizedChassisNo || !Array.isArray(records)) return [];

    return records.filter((record) => {
        const recordChassisNo = String(record?.sasiNo ?? record?.SasiNo ?? '').trim().toUpperCase();
        const recordZNumber = Number(record?.zNumber ?? record?.ZNumber);
        const warrantyFlag = zNumber === 1 ? record?.strWarranty ?? record?.StrWarranty : record?.extWarranty ?? record?.ExtWarranty;

        return recordChassisNo === normalizedChassisNo && recordZNumber === zNumber && String(warrantyFlag ?? '').trim().toUpperCase() === 'X';
    });
};

export const getDateEligibleWarranties = (records, evaluationDate) => {
    const normalizedDate = toDateOrNull(evaluationDate);
    if (!normalizedDate || !Array.isArray(records)) return [];

    return records.filter((record) => {
        const startDate = toDateOrNull(record?.garantiBaslangic ?? record?.GarantiBaslangic);
        const endDate = toDateOrNull(record?.garantiBitis ?? record?.GarantiBitis);
        return isDateInRange(normalizedDate, startDate, endDate);
    });
};

export const resolveVehicleModelFromChassis = (chassis) => {
    if (!chassis || typeof chassis !== 'object') return '';
    const chassisNo = String(chassis?.id ?? chassis?.chassisNo ?? '').trim();
    const candidates = [chassis?.vehicleModelEmissions, chassis?.VehicleModelEmissions, chassis?.vehicleModel, chassis?.model, chassis?.modelName, chassis?.brandModel, chassis?.translatedText];

    for (const candidate of candidates) {
        const normalized = String(candidate ?? '').trim();
        if (!normalized) continue;
        if (chassisNo && normalized === chassisNo) continue;
        return normalized;
    }

    return '';
};